<script setup>
import { ref, computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useCarsGroupsStore } from '@/stores/cars-groups'

const translaterStore   = useTranslaterStore()
const carsGroupsStore   = useCarsGroupsStore()

const getTranslate              = computed(() => translaterStore.getTranslate)
const carsGroupsCreateProcess   = computed(() => carsGroupsStore.carsGroupsCreateProcess)
const carsGroupsCreateMsg       = computed(() => carsGroupsStore.carsGroupsCreateMsg)

const UTACreateCarsGroupName = ref('') 
const UTACreateCarsGroupDescr = ref('') 
const formInvalids = ref({}) 
const formErrors = ref([]) 

function submitCreateCarsGroup() {

    formInvalids.value = {}
    formErrors.value = []

    let data = {}

    if(UTACreateCarsGroupName.value) {
        data.name = UTACreateCarsGroupName.value
    } else {
        formInvalids.value.UTACreateCarsGroupName = true
        formErrors.value.push(getTranslate.value.CARS_GROUPS_CREATE_NAME)
    }

    if(UTACreateCarsGroupDescr.value) {
        data.description = UTACreateCarsGroupDescr.value
    }

    if(formErrors.value.length == 0) {
        carsGroupsStore.createCarsGroup(data)
    }
}
</script>

<template>

    <form class="uta-create-cars-group" @submit.prevent="submitCreateCarsGroup">

        <div class="mb-4 uta-alert uta-alert--danger" v-if="formErrors.length">
            <span class="material-icons uta-alert__icon">error_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate.EFormFields }}:
                <span class="uta-alert__text-item" v-for="(error, index) in formErrors" :key="error">
                    {{ error }}{{ index !== formErrors.length - 1 ? ', ' : '' }} 
                </span>
            </div>
            <button type="button" class="uta-alert__close" @click="formErrors = [], formInvalids = {}">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div class="mb-4 uta-alert uta-alert--danger" v-if="'success' in carsGroupsCreateMsg && !carsGroupsCreateMsg.success">
            <span class="material-icons uta-alert__icon">error_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[carsGroupsCreateMsg.text] || carsGroupsCreateMsg.text }}
            </div>
            <button type="button" class="uta-alert__close" @click="carsGroupsStore.setCarsGroupsCreateMsg({})">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div class="mb-3 form-group">
            <label for="UTACreateCarsGroupName">{{ getTranslate.CARS_GROUPS_CREATE_NAME }}</label>
            <input 
                type="text" 
                class="form-control" 
                :class="{ 'is-invalid' : formInvalids.UTACreateCarsGroupName }"
                @input="delete formInvalids.UTACreateCarsGroupName"
                id="UTACreateCarsGroupName" 
                v-model="UTACreateCarsGroupName"
            >
        </div>

        <div class="form-group">
            <label for="UTACreateCarsGroupDescr">{{ getTranslate.CARS_GROUPS_CREATE_DESCR }}</label>
            <input 
                type="text" 
                class="form-control" 
                id="UTACreateCarsGroupDescr" 
                v-model="UTACreateCarsGroupDescr"
            >
        </div>

        <div class="uta-btns">
            <button type="submit" class="uta-btn uta-btn--main">
                <template v-if="!carsGroupsCreateProcess">
                    {{ getTranslate.BTN_CREATE }}
                </template>
                <template v-else>
                    <div class="spinner-border uta-header__spinner" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </template>
            </button>
        </div>

    </form>

</template>
